export default class SendMailModel {
    public id = 0
    public mail = ''
    public corps = ''
    public files = [] as Blob[]
}
